import {all} from "redux-saga/effects";
import synchronizationWorker from "./synchronizationWorker";
import resetStateWorker from "./resetStateWorker";
import reportProblemWorker from "./reportProblemWorker";
import forkWithErrHandler from "../../../shared/utils/forkWithErrHandler";
import dailyBonusWorker from "./dailyBonusWorker";
import trackLocalizationWorker from "./trackLocalizationWorker";

export default function* commonSagas() {
    const tasks = [
        forkWithErrHandler("commonSagas", "reportProblemWorker", reportProblemWorker),
        forkWithErrHandler("commonSagas", "resetStateWorker", resetStateWorker),
        forkWithErrHandler("commonSagas", "dailyBonusWorker", dailyBonusWorker),
        forkWithErrHandler("commonSagas", "trackLocalizationWorker", trackLocalizationWorker)
    ];

    if (!window.DISABLE_SYNCHRONIZATION) {
        tasks.push(forkWithErrHandler("commonSagas", "synchronizationWorker", synchronizationWorker));
    } else {
        console.warn("[WARN] Synchronization is disabled");
    }

    yield all(tasks);
}